<lib-online-survey-index (copyLink)="onCopyLink($event)">
</lib-online-survey-index>
